<template>
  <div class="hotel-search-box" @click="checkLocale" >
    <div class="">
      <div class="tab-pane animated fadeIn active show" id="hotels">
        <div>
          <!-- <div class="" style="    height: 58px !important;"></div> -->
          <form @submit.prevent="onSubmit">
            <div class="row no-gutters custom-search-input-2">
              <div class="col-md-12">
                <div class="form-group">
                  <dropdown
               
                  v-if="localee == 'fa'"
                    :items="filteredCityList"
                    ref="city"
                    itemText="persianName"
                    :placeholder="$t('HomeHeader.SearchCityAndHotel')"
                    @onSearch="onSearchCity"
                    @onSelect="onSelectCity"
                  >
                    <template #start>
                      <i
                        class="icon icon_pin_alt"
                        :class="{ 'text-danger': $v.city.$anyError }"
                      />
                    </template>
                    <template #noData>
                      <span> {{ $t("HomeHeader.NoCaseFound") }} </span>
                    </template>

                    <template v-slot:item="{ item }">
                      <div class="d-flex" style="color: black">
                        <div class="align-self-center pr-2">
                          <span v-if="item.type == 'City'" class="pl-2"></span>
                          <span
                            style="font-size: 24px; color: gray"
                            :class="{
                              'icon-home-4': item.type == 'Hotel',
                              icon_pin_alt: item.type == 'City',
                            }"
                          ></span>
                        </div>
                        <div class="align-self-stretch">
                          <span  class="i-name">
                            <span v-if="item.type == 'City'"></span>
                            {{ item.persianName }}
                          </span>
                          <!-- <span v-else class="i-name en-name">
                            <span v-if="item.type == 'City'"></span>
                            {{ item.englishName }}
                          </span> -->
                          <span
                            class="d-block"
                            style="font-size: 10px; color: gray"
                            v-if="item.type == 'City'"
                            >{{ $t("City") }}</span
                          >
                          <span
                            class="d-block"
                            style="font-size: 10px; color: gray"
                            v-if="item.type == 'Hotel'"
                            >{{ $t("Hotel") }}</span
                          >
                        </div>
                      </div>
                    </template>
                  </dropdown>
                  <dropdown
                  v-else
                    :items="filteredCityList"
                    ref="city"
                    itemText="englishName"
                    :placeholder="$t('HomeHeader.SearchCityAndHotel')"
                    @onSearch="onSearchCity"
                    @onSelect="onSelectCity"
                  >
                    <template #start>
                      <i
                        class="icon icon_pin_alt"
                        :class="{ 'text-danger': $v.city.$anyError }"
                      />
                    </template>
                    <template #noData>
                      <span> {{ $t("HomeHeader.NoCaseFound") }} </span>
                    </template>

                    <template v-slot:item="{ item }">
                      <div class="d-flex" style="color: black">
                        <div class="align-self-center pr-2">
                          <span v-if="item.type == 'City'" class="pl-2"></span>
                          <span
                            style="font-size: 24px; color: gray"
                            :class="{
                              'icon-home-4': item.type == 'Hotel',
                              icon_pin_alt: item.type == 'City',
                            }"
                          ></span>
                        </div>
                        <div class="align-self-stretch">
                          <span  class="i-name">
                            <span v-if="item.type == 'City'"></span>
                            {{ item.englishName }}
                          </span>
                          <!-- <span v-else class="i-name en-name">
                            <span v-if="item.type == 'City'"></span>
                            {{ item.englishName }}
                          </span> -->
                          <span
                            class="d-block"
                            style="font-size: 10px; color: gray"
                            v-if="item.type == 'City'"
                            >{{ $t("City") }}</span
                          >
                          <span
                            class="d-block"
                            style="font-size: 10px; color: gray"
                            v-if="item.type == 'Hotel'"
                            >{{ $t("Hotel") }}</span
                          >
                        </div>
                      </div>
                    </template>
                  </dropdown>
                </div>
              </div>

              <div class="col-md-6" @click="checkLocale">
                <div class="form-group">
                  <date-picker
                    :highlight="highlightFromDate"
                    ref="fromDate"
                    v-model="fromDate"
                    popover="bottom-right"
                    :locale="localee"
                    :auto-submit="true"
                    @change="onCheckInDateChange"
                    display-format="dddd jDD jMMMM"
                    format="jYYYY/jM/jD"
                    :placeholder="$t('HomeHeader.DepartureDate')"
                    name="departure-input"
                    :min="minFromDate"
                    :show="showCheckInDate"
                    @close="showCheckInDate = false"
                    @click="onCheckInClick"
                    color="#00C3E1"
                  />
                  <!-- <i class="icon_calendar icon" :class="{ 'text-danger': $v.toDate.$anyError }"></i> -->
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group" @click="checkLocale">
                  <date-picker
                    color="#00C3E1"
                    display-format="dddd jDD jMMMM"
                    ref="toDate"
                    :highlight="highlightToDate"
                    :placeholder="$t('HomeHeader.ReturnDate')"
                    name="checkOut-input"
                    popover="bottom-right"
                    :locale="localee"
                    auto-submit
                    @change="onCheckOutDateChange"
                    format="jYYYY/jM/jD"
                    v-model="toDate"
                    :min="minToDate"
                    :show="showCheckOutDate"
                    @close="showCheckOutDate = false"
                    @click="onCheckOutClick"
                  >
                  </date-picker>
                  <!-- <i class="icon_calendar icon" :class="{ 'text-danger': $v.toDate.$anyError }"></i> -->
                </div>
              </div>

              <div class="col-md-12">
                <pdk-room :currentRooms="rooms" @roomChanged="onRoomChange" />
              </div>

              <div class="col-md">
                <input
                  type="submit"
                  style="font-size: 17px"
                  class="btn_search"
                  :value="$t('HomeHeader.Search')"
                />
              </div>
            </div>
          </form>

          <div class="entrance-alert">
            <transition name="fade"
              ><span
                v-if="$v.city.$anyError"
                class="v-arrow v-top entrance-alert-item"
                >{{ $t("City") }}{{ $t("HomeHeader.NotValid") }}</span
              ></transition
            >
            <span v-if="!$v.hotel.$anyError" class="entrance-alert-item"></span>
            <transition name="fade"
              ><span
                v-if="$v.hotel.$anyError"
                class="v-arrow v-top entrance-alert-item"
              ></span
              >{{ $t("Hotel") }}{{ $t("HomeHeader.NotValid") }}</transition
            >
            <span v-if="!$v.hotel.$anyError" class="entrance-alert-item"></span>
            <transition name="fade"
              ><span
                v-if="$v.fromDate.$anyError"
                class="v-arrow v-top entrance-alert-item"
              >
                {{ $t("HomeHeader.DepartureDate")
                }}{{ $t("HomeHeader.NotValid") }}
              </span></transition
            >
            <span
              v-if="!$v.fromDate.$anyError"
              class="entrance-alert-item"
            ></span>
            <transition name="fade">
              <span
                v-if="$v.toDate.$anyError"
                class="v-arrow v-top entrance-alert-item"
                >{{ $t("ReturnDate") }}{{ $t("HomeHeader.NotValid") }}</span
              >
            </transition>
            <span v-if="!$v.toDate.$anyError" class="entrance-alert-item">
            </span>
          </div>
          <transition name="fade">
            <div v-if="totalNight > 0" class="arrow top">
              {{ totalNight }} {{ $t("StayNights") }}
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import PdkRoom from "@/components/PdkRoom";
import dropdown from "@/components/PdkDropdown";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import jalaaliMoment from "moment-jalaali";
import dateUtil from "../../utils/date";
import Store from "../../views/tour/store/index";
import PdkHeader from "@/components/PdkHeader";

Vue.use(Vuelidate);
require("linqjs");

export default {
  store: Store,
  components: { PdkRoom, dropdown, PdkHeader },
  props: {
    hotelList: Array,
    cityList: { type: Array },
    selectedHotel: { type: Object },
  },
  data: () => ({
    birthday: "1987-10-04 00:00:00",
    showCheckInDate: false,
    showCheckOutDate: false,
    rooms: [],
    now: moment(),
    city: null,
    hotel: null,
    cityName: "",
    hotelName: "",
    fromDate: "",
    minFromDate: "",
    minToDate: "",
    maxFromDate: "",
    toDate: "",
    filteredCityList: [],
    cities: [],
    localee: "fa",
    totalNight: 0,
    combineHotelList: [],
    request: {}
  }),

  validations: {
    city: {
      required,
    },
    hotel: {},
    rooms: {
      required,
    },
    fromDate: {
      required,
      // checkDate: function (val) {
      //   var diff = moment(this.toDate).diff(moment(val), "days");
      //   return diff > 0;
      // },
    },
    toDate: {
      required,
      // checkDate: function (val) {
      //   var diff = moment(val).diff(moment(this.fromDate), "days");
      //   return diff > 0;
      // },
    },
  },
     beforeMount(){

    this.checkLocale();
 },

  
  watch: {
    cityList(val) {
      this.cities = val.filter(
        (p) =>
          p.type == "City" &&
          (p.iata == "KIH" || p.iata == "MHD" || p.iata == "SYZ")
      );

      this.filteredCityList = val.filter(() => true);
      this.loadFromRoute();
    },
    hotelList(val) {
      this.combineHotelToCityList(this.cityList, val);
    },
    selectedHotel: function (val) {
      if (val !== null) {
        this.$refs.city.selectItem(val);
        this.$refs.city.$refs.input.focus();
      }
    },
  },
  computed: {
    getAdaults() {
      const params = this.$route.query;
      return JSON.parse(params.rooms).sum((t) => t.adults);
    },
    getChildren() {
      const params = this.$route.query;
      var rooms = JSON.parse(params.rooms);
      var totalChild = 0;

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age >= 2) {
            totalChild = totalChild + 1;
          }
        });
      });
      return totalChild;
    },
    getInfants() {
      const params = this.$route.query;
      var rooms = JSON.parse(params.rooms);
      var totalInfant = 0;

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age < 2) {
            totalInfant = totalInfant + 1;
          }
        });
      });
      return totalInfant;
    },
    getLocale: function(){
      
          this.localee = this.$i18n.locale;
    },
  },
  async created() {
    const currentDate = new Date();
    this.minFromDate = dateUtil.ConvertToPersian(currentDate);
  },
  async mounted() {
    this.isMounted = true;
    var defaultHotel = this.cityList.filter(
      (p) => p.type == "City" && p.iata == "KIH"
    );

    this.$refs.city.selectItem(defaultHotel[0]);
    if (this.cityList.length != 0) {
      this.cities = this.cityList.filter(
        (p) =>
          p.type == "City" &&
          (p.iata == "KIH" || p.iata == "MHD" || p.iata == "SYZ")
      );

      this.filteredCityList = this.cities.filter(() => true);
      this.combineHotelToCityList(this.cities, this.hotelList);
    }
     this.localee = this.$i18n.locale;
    // this.loadFromRoute();
  },

  methods: {
    highlightFromDate(formatted, dateMoment, checkingFor) {
      const selectedToDate = this.toDate;

      let attributes = { title: "Today is " + formatted };
      if (checkingFor === "day" && formatted === selectedToDate) {
        attributes["class"] = "highlighted-date";
        attributes["title"] = "تاریخ برگشت";
        attributes["style"] =
          "color: white;border-radius: 50%;font-size: 15px;";
      }

      return attributes;
    },
    checkLocale() {
      this.localee = this.$i18n.locale;
    },
    highlightToDate(formatted, dateMoment, checkingFor) {
      const selectedFromDate = this.fromDate;

      let attributes = { title: "Today is " + formatted };
      if (checkingFor === "day" && formatted === selectedFromDate) {
        attributes["class"] = "highlighted-date";
        attributes["title"] = "تاریخ رفت";
        attributes["style"] =
          "color: white;border-radius: 50%;font-size: 15px;";
      }

      return attributes;
    },
    calculateTotalNight() {
      this.totalNight = 0;
      if (
        this.fromDate != "" &&
        this.fromDate != null &&
        this.toDate != "" &&
        this.toDate != null
      ) {
        let fDate = jalaaliMoment(this.fromDate, "jYYYY/jMM/jDD").format(
          "YYYY/MM/DD"
        );
        let tDate = jalaaliMoment(this.toDate, "jYYYY/jMM/jDD").format(
          "YYYY/MM/DD"
        );

        var startDate = moment(fDate);
        var endDate = moment(tDate);
        let duration = moment.duration(endDate.diff(startDate));

        let diff = Math.round(duration.asDays());
        //  var diff = moment(this.toDate).diff(moment(this.fromDate), "days");

        this.totalNight = diff;
      } else {
        this.totalNight = 0;
      }
    },

    calculateMinToDate() {
      this.showCheckOutDate = true;
      if (this.minFromDate == "" || this.minToDate == null) {
        const currentDate = new Date();
        this.minToDate = dateUtil.ConvertToPersian(currentDate);
      } else {
        this.minToDate = jalaaliMoment(this.fromDate, "jYYYY/jM/jD").format(
          "jYYYY/jMM/jDD"
        );
      }
    },
    onCheckInDateChange() {
      setTimeout(() => (this.showCheckOutDate = true), 500);
      this.showCheckOutDate = true;
      this.calculateMinToDate();
      this.calculateTotalNight();

      if (this.toDate !== "") {
        this.maxFromDate = jalaaliMoment(this.toDate, "jYYYY/jM/jD").format(
          "jYYYY/jMM/jDD"
        );
      } else {
        this.maxFromDate = "";
      }
    },
    onCheckOutDateChange() {
      this.calculateTotalNight();
    },
    onCheckInClick() {
      this.calculateTotalNight();

      this.showCheckInDate = true;

      const currentDate = new Date();
      this.minFromDate = dateUtil.ConvertToPersian(currentDate);
      if (this.toDate !== "") {
        this.maxFromDate = jalaaliMoment(this.toDate, "jYYYY/jM/jD").format(
          "jYYYY/jMM/jDD"
        );
      } else {
        this.maxFromDate = "";
      }
    },
    onCheckOutClick() {
      this.showCheckOutDate = true;
      if (this.minFromDate == "" || this.minToDate == null) {
        const currentDate = new Date();
        this.minToDate = dateUtil.ConvertToPersian(currentDate);
      } else {
        this.minToDate = jalaaliMoment(this.fromDate, "jYYYY/jM/jD").format(
          "jYYYY/jMM/jDD"
        );
      }
    },
    onRoomChange(rooms) {
      this.rooms = rooms;
    },

    onSearchCity(search) {
      if (typeof search === "undefined") search = "".toString();

      search = search.toString().toLowerCase().trim();

      if (typeof this.cities !== undefined && this.cities.length <= 0) {
        this.filteredCityList = [];
        return;
      }

      if (search.trim() === "" || search.length < 3) {
        this.filteredCityList = this.cities.sort((t) => t.order).slice(0, 5);
        return;
      }

      this.filteredCityList = this.combineHotelList
        .filter((t) => t.persianName.toString().toLowerCase().includes(search))
        .slice(0, 5);
    },

    onSelectCity(item) {
      this.city = item;
      this.cityName = item?.persianName;
      this.filteredCityList = this.cities.filter(() => true);
      console.log(this.filteredCityList);
    },

    onSubmit() {
      this.$v.$touch();
      this.$refs.city.validate();

      if (this.$v.$invalid) return;

      if (this.$refs.city.selected.type == "City")
        this.$router
          .push({
            name: "hotelresult",
            query: {
              page: 1,
              pageNumber: 1,
              pageSize: 10,
              skipCount: 0,
              totalRows: 10,
              toPrice: 200000000,
              city: this.city.iata,
              startDate: jalaaliMoment(this.fromDate, "jYYYY/jM/jD").format(
                "YYYY/MM/DD"
              ),
              endDate: jalaaliMoment(this.toDate, "jYYYY/jM/jD").format(
                "YYYY/MM/DD"
              ),
              rooms: JSON.stringify(this.rooms),
            },
          })
          .catch(() => {});
      else if (this.$refs.city.selected.type == "Hotel") {
        this.$router
          .push({
            name: "hotelrooms",
            query: {
              hotelId: this.$refs.city.selected.hotelId,
              city: this.city.iata,
              startDate: jalaaliMoment(this.fromDate, "jYYYY/jM/jD").format(
                "YYYY/MM/DD"
              ),
              endDate: jalaaliMoment(this.toDate, "jYYYY/jM/jD").format(
                "YYYY/MM/DD"
              ),
              rooms: JSON.stringify(this.rooms),
            },
          })
          .catch(() => {});
      }
    },

    loadFromRoute() {
      const params = this.$route.query;

      if (params.city) {
        const search = params.city.trim();
        const items = this.cityList.filter(
          (item) => item.iata.trim() == search
        );

        if (Array.isArray(items) && items.length > 0) {
          this.$refs.city.selectItem(items[0]);
        }
      }

      if (params.startDate && params.startDate.trim() != "")
        this.fromDate = jalaaliMoment(params.startDate, "YYYY/MM/DD").format(
          "jYYYY/jMM/jDD"
        );

      if (params.endDate && params.endDate.trim() != "")
        this.toDate = jalaaliMoment(params.endDate, "YYYY/MM/DD").format(
          "jYYYY/jMM/jDD"
        );
    },
    combineHotelToCityList(cityItem, hotelItem) {
      cityItem.forEach((element) => {
        this.combineHotelList.push(element);
      });

      hotelItem.forEach((element) => {
        this.combineHotelList.push(element);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.search-title {
  text-align: center;
  margin-bottom: 4%;
  margin-top: 7%;
}

.search-title h2 {
  color: whitesmoke;
}

.search-box {
  background: rgba(4, 58, 84, 0.8);
  padding: 2%;
  border-radius: 10px;
  margin-bottom: 15px;
}

.highlighted-date .vpd-day-text {
  color: #ef6c00 !important;
}

.arrow {
  position: absolute;
  left: 10%;
  top: 60%;
  text-align: center;
  padding: 5px 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  background: #00c3e1;
  color: #ffffff;
  font-size: 14px;
}

.arrow::after {
  content: "";
  position: absolute;
  top: 0;
  width: 0;
  height: 0;
}

element.style {
  font-size: 17px;
}

.custom-search-input-2 input[type="submit"] {
  -webkit-border-radius: 0 0 5px 5px;
  -moz-border-radius: 0 0 5px 5px;
  -ms-border-radius: 0 0 5px 5px;
  border-radius: 0 0 5px 5px;
}

.v-arrow {
  /* z-index: 1000; */
  margin-top: 19px;
  max-width: auto;
  /* min-width: 200px; */
  margin-left: 1%;
  /* margin-right: auto; */
  position: sticky;
  /* margin: 10px; */
  border-radius: 7px;
  text-align: center;
  padding-top: 8px;
  padding-bottom: 8px;
  background: #f95379;
  color: #ffffff;
  font-size: 12px;
}

.v-arrow::after {
  content: "";
  position: absolute;
  top: 0;
  width: 0;
  height: 0;
}

.v-top::after {
  right: -17px;
  top: 6px;
  border-width: 9px;
  border-color: transparent transparent transparent #f95379;
  border-style: solid;
}

.top::after {
  right: -17px;
  top: 6px;
  border-width: 9px;
  border-color: transparent transparent transparent #00c3e1;
  border-style: solid;
}

.custom-date-icon:hover {
  cursor: pointer;
  color: #365ab2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>